var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600px",
        title: "View Upload Content",
        visible: _vm.dialogVisible,
        "split-line": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.onClose,
        closed: _vm.onClosed,
      },
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "190px" } },
        [
          _vm.data
            ? [
                _c("el-form-item", { attrs: { label: "Content Category" } }, [
                  _c("span", [_vm._v(_vm._s(_vm.data.CategoryName))]),
                ]),
                _c("el-form-item", { attrs: { label: "Short Title" } }, [
                  _c("span", [_vm._v(_vm._s(_vm.data.ShortTitle))]),
                ]),
                _c("el-form-item", { attrs: { label: "Search Term" } }, [
                  _c("span", [_vm._v(_vm._s(_vm.data.SearchTerm))]),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "Allow Full Article Request" } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.data.FullPaperRequest === 1 ? "Yes" : "No") +
                        " "
                    ),
                  ]
                ),
                _c("el-form-item", { attrs: { label: "Any Comments" } }, [
                  _c(
                    "div",
                    {
                      ref: "commentWrapper",
                      staticClass: "any-comments-wrapper",
                    },
                    [_vm._v(" " + _vm._s(_vm.data.AnyComments) + " ")]
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }